<template>
  <div
    class="confirm-cancel-subscription-modal"
    :class="[$theme.darkTheme ? 'bg-color-modal-dark' : 'bg-color-modal-light']"
  >
    <main :style="{ color: $theme.darkTheme ? '#fff' : '#333' }">
      <div class="row bold title">
        <div class="col"><p>Cancelar assinatura</p></div>
      </div>

      <div class="row" style="margin-bottom: 0">
        <div class="col">
          <p>
            Ao cancelar sua assinatura, você terá acesso ao conteúdo até
            {{ nextBillingDate | formatDate }}. Depois disso, não será mais
            possível acessá-lo.
          </p>

          <p>Ainda deseja cancelar?</p>
        </div>
      </div>

      <div class="row" style="margin-bottom: 0">
        <div class="col s4">
          <button
            class="btn waves-effect waves-light btn--reject"
            style="width: 100%"
            @click="rejectCancel"
          >
            Voltar
          </button>
        </div>

        <div class="col s8">
          <button
            class="btn waves-effect waves-light"
            :style="{ backgroundColor: $theme.primaryColor }"
            style="width: 100%"
            @click="acceptCancel"
          >
            Sim, cancelar assinatura
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { formatDate } from "@/filters/formatDate";
import HeaderPage from "@/layout/HeaderPage";

export default {
  name: "ConfirmCancelSubscription",
  components: {
    HeaderPage,
  },
  props: {
    title: String,
    subscriptionId: Number,
    nextBillingDate: String,

    acceptHandler: Function,
    rejectHandler: Function,
  },
  data() {
    return {
      loading: true,
    };
  },

  methods: {
    acceptCancel() {
      this.acceptHandler();
    },
    rejectCancel() {
      this.rejectHandler();
    },
  },
  filters: {
    formatDate(date) {
      return formatDate(new Date(date));
    },
  },
};
</script>

<style lang="scss">
.confirm-cancel-subscription-modal {
  padding: 18px 12px;

  &.bg-color-modal-dark {
    background-color: #23232a !important;
  }

  .title {
    font-family: robotobold, sans-serif;
    font-size: 1.2rem;
    margin-bottom: 0px;

    p {
      margin: 0;
    }
  }

  .btn--reject {
    filter: grayscale(1);
  }
}
</style>
